<template>
  <div class="page">

    <div class="top">

      <div>
        <!-- Create new keyword -->
        <div class="form">
          <form class="form-inline" v-on:submit.prevent="createKeyword()">
            <select v-model="type">
              <option value="keyword">Keyword</option>
              <option value="ipv4">IPv4 address</option>
              <option value="email">Email address</option>
              <option value="domain">Domain name</option>
              <option value="internal">Internal keyword</option>
              <option value="username">User name</option>
              <option value="brandname">Brand name</option>
              <option value="companyname">Company Name</option>
              <option value="personalname">Personal name</option>
              <option value="phonenumber">Phone number</option>
              <option value="iban">IBAN</option>
              <option value="creditcard">Credit card number</option>
              <option value="acountnumber">Bank account number</option>
            </select>
            <input v-model="value" size="50" placeholder="Keyword value" @change="onValueChange"/>
            <input id="valueFileInput" type="file" @change="onFileChange" style="display: none;" />
            <input type="button" value="or file" onclick="document.getElementById('valueFileInput').click();" />
            <button type="submit">Create new</button>
          </form>
          <div class="hint">Create keywords one by one or from file. Supported file types:
            <ul>
              <li>.txt - all keywords of same type listed one keyword per line</li>
              <li>.xlsx - keyword types in first row and keywords listed below in respective columns (type select above has no effect)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="top">
      <div></div>
      <!--
      <div>
        <button id="updateKeywordsBtn" @click="updateKeywords" disabled>Update all</button>
        <button id="enableKeywordsBtn" @click="enableKeywords">Enable all</button>
        <button id="disableKeywordsBtn" @click="disableKeywords">Disable all</button>
        <button id="resetKeywordsBtn" @click="resetKeywords">Reset all</button>
        <button id="deleteKeywordsBtn" @click="deleteKeywords">Delete all</button>
      </div> 
      -->
      <div>
        <select v-model="bulkMethod">
          <option value="" disabled selected>Bulk method</option>
          <option value="enable">Enable</option>
          <option value="disable">Disable</option>
          <option value="update">Update</option>
          <option value="reset">Reset</option>
          <option value="delete">Delete</option>
        </select>
        <button class="btn" @click="setSelectedKeywords(true)">Select all</button>
        <button class="btn" @click="setSelectedKeywords(false)">Deselect all</button>
        <button class="btn" @click="applyBulk" :disabled="!bulkMethod">Apply to selected</button>
      </div>
    </div>

    <div class="keywords">

      <div class="top">
        <div>Keywords {{filteredKeywords.length}} of {{keywords.length}}</div>
        <div>
          Sort:
          <select v-model="keywordsFilter.sortAttr">
            <option value="type">Type</option>
            <option value="value">Value</option>
            <option value="total_alerts">Alerts</option>
            <option value="total_documents">Documents</option>
            <option value="enabled">Enabled</option>
            <option value="updating">Updating</option>
          </select>
          <input type="checkbox" id="filterCheckbox" v-model="keywordsFilter.sortReverse">
          <label for="filterCheckbox">reverse</label>
        </div>
        <div>
          Filter:
          <select v-model="keywordsFilter.type">
            <option value="">All</option>
            <option value="keyword">Keyword</option>
            <option value="ipv4">IPv4 address</option>
            <option value="email">Email address</option>
            <option value="domain">Domain name</option>
            <option value="internal">Internal keyword</option>
            <option value="username">User name</option>
            <option value="brandname">Brand name</option>
            <option value="companyname">Company Name</option>
            <option value="personalname">Personal name</option>
            <option value="phonenumber">Phone number</option>
            <option value="iban">IBAN</option>
            <option value="creditcard">Credit card number</option>
            <option value="acountnumber">Bank account number</option>
          </select>
          <input v-model="keywordsFilter.value" size="25" placeholder="Value"/>
        </div>
        <div>
          <span v-show="updateProgress < 100">Updating {{updateProgress}}% </span>
          <button @click="refreshKeywords">Refresh</button>
        </div>
      </div>
      <Keyword v-for="keyword in filteredKeywords" :key="keyword.id" :keyword="keyword"/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  display: flex;
  justify-content: space-between;
}
.hint {
  font-size: small;
}
.search {
}
.keywords {
  margin-top: 10px;
}
.btn {
  margin-right: 3px;
}
</style>

<script>
import { mapState } from 'vuex'
import Keyword from '@/components/Keyword.vue'

export default {
  name: 'keywords',
  components: {
    Keyword
  },
  computed: {
    filteredKeywords() {
      if (!this.keywords || !this.keywords.length) return []
      // Filter according to type and search
      var keywords = this.keywords.filter(keyword => {
        if (this.keywordsFilter.type && this.keywordsFilter.type != keyword.type) return false
        if (keyword.value.toLowerCase().indexOf(this.keywordsFilter.value.toLowerCase()) === -1) return false
        return true
      })
      // Sort keywords
      var sortAttr = this.keywordsFilter.sortAttr
      var sortReverse = this.keywordsFilter.sortReverse
      keywords.sort(function(a, b) {
        // Strings
        if (typeof a[sortAttr] === 'string'){
          if (sortReverse)
            return b[sortAttr].toLowerCase().localeCompare(a[sortAttr].toLowerCase())
          return a[sortAttr].toLowerCase().localeCompare(b[sortAttr].toLowerCase())
        }
        // Other
        if (sortReverse)
          return a[sortAttr] - b[sortAttr]// Ascending
        return b[sortAttr] - a[sortAttr]// Ascending
      })
      return keywords
    },
    updateProgress () {
      if (!this.keywords.length) return 100
      var updating = 0
      for (var i in this.keywords) {
        if (this.keywords[i].updating) updating += 1
      }
      return Math.floor((1 - updating / this.keywords.length) * 100)
    },
    ...mapState([
      'debugMode',
      'apiAuth',
      'account',
      'profile',
      'keywords',
      'keywordsFilter'
    ])
  },
  watch: {
    profile () {
      this.refreshKeywords()
    }
  },
  mounted () {
    this.refreshKeywords()
  },
  methods: {
    getSelectedKeywords () {
      // console.log('getSelectedKeywords')
      var selectedKeywords = []
      for (var keyword in this.filteredKeywords) {
        if (this.filteredKeywords[keyword].selected)
          selectedKeywords.push(this.filteredKeywords[keyword])
      }
      return selectedKeywords
    },
    setSelectedKeywords (bool) {
      // console.log('setSelectedKeywords', bool)
      for (var filteredKeyword in this.filteredKeywords) {
        this.filteredKeywords[filteredKeyword].selected = bool
      }
    },
    refreshKeywords () {
      if (!this.account.id) return
      this.$store.dispatch('loadKeywords')
    },
    onFileChange (event) {
      if (event.target.files) {
        this.valueFile = event.target.files[0]
        this.value = this.valueFile.name
      }
    },
    onValueChange () {
      document.getElementById('valueFileInput').value = null
    },
    createKeyword () {
      if (!this.value && !this.values) return
      this.$store.dispatch('createKeyword', {
        type: this.type,
        value: this.value,
        value_file: this.valueFile
      })
      // this.type = ''#Don't reset the type
      this.value = ''
      this.valueFile = null
      document.getElementById('valueFileInput').value = null
    },
    updateKeywords () {
      document.getElementById('updateKeywordsBtn').disabled = true
      var params = {}
      if (this.profile) params['profile_id'] = this.profile.id
      this.apiAuth.post('/keywords/update', params).then( () => {
        this.$store.dispatch('loadKeywords')
        alert('Started updating all keywords')
        document.getElementById('updateKeywordsBtn').disabled = false
      })
    },
    resetKeywords () {
      document.getElementById('resetKeywordsBtn').disabled = true
      var params = {}
      if (this.profile) params['profile_id'] = this.profile.id
      this.apiAuth.post('/keywords/reset', params).then( () => {
        this.$store.dispatch('loadKeywords')
        alert('Reset all keywords')
        document.getElementById('resetKeywordsBtn').disabled = false
      })
    },
    enableKeywords () {
      if (!confirm('Are you sure? This will enable all keywords!')) return
      this.$store.dispatch('updateKeywords', {enabled: true})
    },
    disableKeywords () {
      if (!confirm('Are you sure? This will disable all keywords!')) return
      this.$store.dispatch('updateKeywords', {enabled: false})
    },
    deleteKeywords () {
      if (!confirm('Are you sure? This will delete all keywords permanently!')) return
      this.$store.dispatch('deleteKeywords')
    },
    applyBulk () {
      if (!this.bulkMethod) return
      var selectedKeywords = this.getSelectedKeywords()
      if (!selectedKeywords.length) return
      if (!confirm('Are you sure? This will ' + this.bulkMethod + ' all selected keywords!')) return
      var params = {
        method: this.bulkMethod,
        keywords: selectedKeywords.map(kw => kw.id).join(',')
      }
      this.apiAuth.post('/keywords/bulk', params).then( () => {
        this.$store.dispatch('loadKeywords')
      })

    }
  },
  data () {
    return {
      type: 'keyword',
      value: '',
      valueFile: null,
      bulkMethod: ''
    }
  }
}
</script>
